import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { AppLayout } from '../components/layout/AppLayout';
import CommunicationsInbox from '../components/CommunicationsInbox';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

const CommunicationsPage = () => {
  const { user, firebaseUser, loading } = useAuth();
  const navigate = useNavigate();
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    if (!loading && !firebaseUser) {
      navigate('/login');
      return;
    }

    if (firebaseUser) {
      // TODO: Get user profile to determine user type and details
      // For now, assuming PFI user
      setUserProfile({
        id: firebaseUser.uid,
        name: firebaseUser.displayName || firebaseUser.email,
        email: firebaseUser.email,
        type: 'pfi' // This should be determined from user profile
      });
    }
  }, [firebaseUser, loading, navigate]);

  if (loading || !userProfile) {
    return (
      <AppLayout>
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-500 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading communications...</p>
          </div>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div className="max-w-7xl">
        {/* Header */}
        <div className="bg-gradient-to-r from-pink-500 to-purple-600 rounded-xl p-6 mb-6 text-white shadow-lg">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <ChatBubbleLeftRightIcon className="w-10 h-10 mr-4 text-white" />
              <div>
                <h1 className="text-3xl font-bold mb-1">Communications Centre</h1>
                <p className="text-pink-100">
                  Manage all communications across all projects
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Communications Inbox */}
        <div className="bg-white rounded-lg shadow-sm">
          <CommunicationsInbox
            userType={userProfile.type}
            userId={userProfile.id}
            projectId={null} // null = main inbox (all projects)
            userName={userProfile.name}
            userEmail={userProfile.email}
          />
        </div>
      </div>
    </AppLayout>
  );
};

export default CommunicationsPage;